/**
 * En-tête Dawn V2 : petits comportements en plus de ceux de Dawn.
 *  1. Méga-menu « produits et collections » : au survol (ou au clic sur écran tactile), on montre les cartes de la collection ;
 *     la touche Échap le ferme.
 *  2. Tiroir mobile : le bouton « fermer » de la barre de titre ferme le tiroir comme le bouton hamburger.
 * Chargé par sections/header.liquid. Tout passe par la délégation d'événements : rien à refaire quand la section est rechargée.
 */
(() => {
  if (window.v2HeaderReady) return;
  window.v2HeaderReady = true;

  const ITEM = '.products-mega-menu__item';
  const ACTIVE = 'products-mega-menu__item--active';

  function activate(item) {
    if (!item || item.classList.contains(ACTIVE)) return;
    const list = item.parentElement;
    list.querySelectorAll(`:scope > .${ACTIVE}`).forEach((other) => other.classList.remove(ACTIVE));
    item.classList.add(ACTIVE);
  }

  // Méga-menu : survol souris et focus clavier.
  document.addEventListener('mouseover', (event) => activate(event.target.closest?.(ITEM)));
  document.addEventListener('focusin', (event) => activate(event.target.closest?.(ITEM)));

  // Écran tactile : le premier toucher montre les cartes, le second ouvre la collection.
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.(`${ITEM} > a`);
    if (!link || !window.matchMedia('(hover: none)').matches) return;
    const item = link.parentElement;
    if (item.classList.contains(ACTIVE)) return;
    event.preventDefault();
    activate(item);
  });

  // Méga-menu : la touche Échap le ferme et remet le focus sur son titre.
  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest?.('.products-mega-menu-wrapper');
    if (!menu?.querySelector('details[open]')) return;
    menu.close?.();
    menu.querySelector('summary')?.focus();
  });

  // Tiroir mobile : bouton « fermer » de la barre de titre.
  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('.menu-drawer__close-menu-btn');
    if (!button) return;
    const details = button.closest('header-drawer')?.querySelector(':scope > details');
    if (details?.hasAttribute('open')) details.querySelector(':scope > summary')?.click();
  });
})();
